import React from 'react';
import Duanxi from  '../assets/duanXi.jpg'
import hanYu from  '../assets/hanYu.jpg'
import hanPeng from '../assets/hanPeng.jpg'
import liuYanNi from '../assets/liuYanNi.jpg'
import wangQi from '../assets/wangQi.jpg'
import sunMaoQuan from '../assets/sunMaoQuan.jpg'
import liuJian from  '../assets/liuJian.jpg'
import liuPingAn from  '../assets/liuPingAn.jpg'
import gaoKeXin from  '../assets/gaoKeXin.jpg'
import liZhongRui from '../assets/liZhongRui.jpg'
import xuXinYu from  '../assets/xuXinYu.jpg'
import wangGuanQun from '../assets/wangGuanQun.jpg'



function Member() {
  const MemberInfo = [
    {
        grade:'2022',
        members:[
            {
                pic: Duanxi,
                name: '段曦',
                direction: '真实感场景实时渲染',
                sentence: '认真学习数学物理真的有用。'
            },
            {
                pic: hanYu,
                name: '韩宇',
                direction: '三维可视化',
                sentence: '看到这句话的人抵消一次拒稿。'
            },
            {
                pic: hanPeng,
                name: '韩鹏',
                direction: '基于深度学习的海洋数据超分',
                sentence: '岁月如一曲美妙的旋律，每个人都是独特的艺术家，让我们一起展现属于自己的精彩创作！'
            },
            {
                pic: liuYanNi,
                name: '刘艳妮',
                direction: '深度学习实现超分辨率',
                sentence: '不应该呀，实在不行重启下试试？'
            },
            {
                pic: wangQi,
                name: '王麒',
                direction: '计算机视觉',
                sentence: '深度学习。'
            },
            {
                pic: sunMaoQuan,
                name: '孙茂荃',
                direction: '科学数据降尺度',
                sentence: ' 我个人认为这个意大利面就应该拌42号混凝土。'
            }
        ]
    },
    {
        grade:'2023',
        members:[
            {
                pic: liuPingAn,
                name: '刘平安 ',
                direction: '海洋地形增强',
                sentence: '欢迎对图形学感兴趣的小伙伴入组，导师人超好，师兄师姐人也超好，走过路过不要错过。'
            },
            {
                pic: liuJian,
                name: '刘健',
                direction: 'AIGC',
                sentence: '一切都是最好的安排。'
            },
            {
                pic: gaoKeXin,
                name: '高可欣',
                direction: 'AIGC',
                sentence: '十年一瞬如沧海，谁人还逝藏海花。'
            },
            {
                pic: liZhongRui,
                name: '李中瑞',
                direction: '场景生成',
                sentence: '编译成功。'
            },
            {
                pic: xuXinYu,
                name: '徐欣雨 ',
                direction: "三维可视化",
                sentence: '擅长wps、word、excel等软件的安装与卸载，精通PR、PS等单词的拼写，熟悉Linux、Windows、Android等系统的开关机。'
            },
            {
                pic: wangGuanQun,
                name: '王冠群 ',
                direction: '体积绘制，离线渲染，人机交互领域等',
                sentence: '向往美好，向往自由。'

            }
        ]
    }
  ];

  return (
    <div className='md:w-7/12 sm:w-3/4 mx-auto' id='member'>
        <div>
            <h3 className='text-black tracking-widest font-semibold py-4  lg:text-4xl lg:leading-loose md:text-3xl sm:w-fit sm:text-2xl s sm:leading-loose'>
                实验室人员介绍
            </h3>
            <p className='text-28 text-black sm:tracking-widest sm:leading-loose w-full'>
                我们实验室是一个充满活力与创造力的团队，共有12位成员。他们分别在实时渲染、三维可视化、海洋数据超分辨率等领域有着丰富的经验和专业技能。            </p>
        </div>
        <div className="md:block sm:hidden">
            {MemberInfo.map((group, groupIndex) => (
                <div key={groupIndex} className='my-20'>
                <h2 className='text-[#34623F] tracking-widest font-semibold py-4  lg:text-3xl lg:leading-loose md:text-2xl sm:w-fit sm:text-xl s sm:leading-loose font-limelight'>{group.grade}</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 lg:gap-x-48 lg:gap-y-32 md:gap-x-28 md:gap-y-20">
                    {group.members.map((member, memberIndex) => (
                    <div key={memberIndex} >
                        <div className='relative overflow-hidden  group'>
                            <img
                                src={member.pic}
                                alt={member.name}
                                className="md:w-full h-auto sm:w-3/4 sm:mx-auto  rounded-xl shadow-lg transition-all cursor-pointer hover:scale-110 duration-500 ease-in-out z-10"
                            />
                            {/*<div className="w-full absolute bottom-0 bg-black bg-opacity-50 flex items-end text-white px-4 py-2 opacity-0 transition-opacity duration-500 ease-in-out group-hover:opacity-100">*/}
                            {/*    <p className="lg:text-sm md:text-xs sm:text-basesm:tracking-widest sm:leading-loose">{member.name}</p>*/}
                            {/*</div>*/}
                        </div>
                        <div className='sm:mb-16 md:mb-0 pl-2 mt-4'>
                            <h3 className='md:text-center lg:text-sm md:text-xs sm:text-base text-black sm:tracking-widest sm:leading-loose '>{member.name}</h3>
                            <h3 className='md:text-center lg:text-sm md:text-xs sm:text-base text-black sm:tracking-widest sm:leading-loose '>{member.direction}</h3>
                            <p className='md:text-left lg:text-xs md:text-xs sm:text-base text-[#34623F] sm:tracking-widest sm:leading-loose break-all'>{member.sentence}</p>
                        </div>
                    </div>
                    ))}
                </div>
        </div>
      ))}
    </div>
        <div className="md:hidden sm:block">
            {MemberInfo.map((group, groupIndex) => (
                <div key={groupIndex} className='my-20'>
                    <h2 className='text-[#34623F] tracking-widest font-semibold py-4  lg:text-3xl lg:leading-loose md:text-2xl sm:w-fit sm:text-xl s sm:leading-loose font-limelight'>{group.grade}</h2>
                    <div className="grid grid-cols-1 gap-8">
                        {group.members.map((member, memberIndex) => (
                            <div key={memberIndex} className="flex place-items-center">
                                <div className='relative overflow-hidden  group w-1/2'>
                                    <img
                                        src={member.pic}
                                        alt={member.name}
                                        className="h-auto w-1/2 shadow-lg transition-all cursor-pointer hover:scale-110 duration-1000 ease-in-out z-10 mt-4"
                                    />
                                </div>
                                <div className='items-center w-1/2'>
                                    <h3 className='text-xs  text-black sm:tracking-widest sm:leading-loose'>{member.name}</h3>
                                    <h3 className='text-xs  text-black sm:tracking-widest sm:leading-loose '>{member.direction}</h3>
                                    <p className='text-xs text-[#34623F] sm:tracking-widest sm:leading-loose'>{member.sentence}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>

    </div>

  )
}

export default Member
